import React, { Component } from "react";
import { Container, Row, Col, Media } from "reactstrap";

import classes from "./Header.module.scss";

import logoBinuy from "./images/logoBinuy.jpg";
import logoBinuySmall from "./images/logoBinuySmall.png";
import logoIsrael from "./images/logoIsrael.png";
import logoIsraelSmall from "./images/logoIsraelSmall.png";
import logoMod from "./images/logoMod.png";
import logoModSmall from "./images/logoModSmall.png";

class Header extends Component {
  constructor() {
    super();
    this.state = {
      smMode: false
    };
  }

  updateDimensions() {
    if (window.innerWidth <= 768 || window.screen.width <= 768) {
      this.setState({ smMode: true });
    } else {
      this.setState({ smMode: false });
    }
  }

  /**
   * Add event listener
   */
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }
  render() {
    return (
      <Container className={classes.header}>
        <Row>
          <Col className={classes.binuyLogoCol} lg="1" sm="2" xs="2">
            <Media
              object
              src={this.state.smMode ? logoBinuySmall : logoBinuy}
              alt="לוגו אגף בינוי"
              className={classes.logoBinuy}
            />
          </Col>
          <Col lg="8" sm="7" xs="6" className={classes.headerText}>
            <span className={classes.headerBigText}>
              המפרט הכללי לעבודות בנייה{" "}
            </span>
            <span className={classes.headerSmallText}>| הספר הכחול</span>
          </Col>
          <Col className={classes.leftLogosCol} sm="3" xs="4">
            <Media
              object
              src={this.state.smMode ? logoModSmall : logoMod}
              alt="לוגו משרד הביטחון"
              className={classes.logoMod}
            />
            <Media
              object
              src={this.state.smMode ? logoIsraelSmall : logoIsrael}
              alt="לוגו מדינת ישראל"
              className={classes.logoIsrael}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Header;
